import React from 'react';
import { Phone, Mail, MapPin } from 'lucide-react';
import WhatsAppButton from './WhatsAppButton';

const ACCENT = '#1a5fff';

const INFO_ITEMS = [
  { icon: Phone, label: 'Call us', text: '+91 95426 43011' },
  { icon: Mail, label: 'Email', text: 'sanjay.sahu@digihr.in' },
  { icon: MapPin, label: 'Office', text: 'T-19 Tower, 16th Floor, Rani Gunj\nSecunderabad, Telangana', sub: 'Sciverse Solutions Pvt. Ltd.' },
];

const ContactInfo = () => (
  <>
    <WhatsAppButton style={{ marginBottom: 28 }} />
    {INFO_ITEMS.map(({ icon: Icon, label, text, sub }) => (
      <div key={label} style={{ display: 'flex', alignItems: 'flex-start', gap: 14, marginBottom: 22 }}>
        <div style={{ width: 42, height: 42, borderRadius: 12, background: '#e8efff', color: ACCENT, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}><Icon size={18} strokeWidth={1.75} /></div>
        <div>
          <h4 style={{ fontSize: 13, fontWeight: 600, marginBottom: 2 }}>{label}</h4>
          <p style={{ fontSize: 14, color: '#3a3f4a', margin: 0, whiteSpace: 'pre-line' }}>{text}</p>
          {sub && <p style={{ fontSize: 12, color: '#717888', margin: '2px 0 0' }}>{sub}</p>}
        </div>
      </div>
    ))}
  </>
);

export default ContactInfo;
